import { onUnmounted, type Ref, watch } from 'vue';

export const useSwrPolling = (
  mutate: () => Promise<unknown>,
  shouldContinue: Ref<boolean>,
  intervalMs: number,
) => {
  let timeout: number | undefined;
  let epoch = 0;

  const stop = () => {
    epoch += 1;
    clearTimeout(timeout);
    timeout = undefined;
  };

  const start = () => {
    stop();
    const myEpoch = epoch;
    const poll = async () => {
      await mutate();
      if (myEpoch !== epoch) return;
      if (!shouldContinue.value) {
        stop();
        return;
      }
      timeout = window.setTimeout(poll, intervalMs);
    };
    poll();
  };

  watch(
    shouldContinue,
    on => {
      if (on && timeout === undefined) {
        start();
      } else if (!on && timeout !== undefined) {
        stop();
      }
    },
    { immediate: true },
  );

  onUnmounted(stop);

  return { stop };
};
